var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chekcbox_on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 23,
    height: 23,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02_StockAwards",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_05",
    transform: "translate(-689.000000, -540.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(370.000000, 206.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Change-by-year",
    transform: "translate(20.000000, 71.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(1.000000, 185.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selection/Checkbox/Alone/On",
    transform: "translate(298.000000, 78.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chekcbox_on"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-53",
    stroke: "#00B550",
    strokeWidth: 2,
    points: "18 8 9.515 16 6 11.4281674"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkbox-on.1d3c98c3b62f4838bc0109d3c314b7fb.svg";
export { ForwardRef as ReactComponent };